"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpellRangeAreaFn = exports.getSpellEffectFn = void 0;
var attraction_effect_1 = require("./effects/attraction-effect");
var blood_sharing_effect_1 = require("./effects/blood-sharing-effect");
var distraction_effect_1 = require("./effects/distraction-effect");
var last_resort_effect_1 = require("./effects/last-resort-effect");
var motivation_effect_1 = require("./effects/motivation-effect");
var move_effect_1 = require("./effects/move-effect");
var side_attack_effect_1 = require("./effects/side-attack-effect");
var simple_attack_effect_1 = require("./effects/simple-attack-effect");
var slump_effect_1 = require("./effects/slump-effect");
var switch_effect_1 = require("./effects/switch-effect");
var sword_sting_effect_1 = require("./effects/sword-sting-effect");
var treacherous_blow_effect_1 = require("./effects/treacherous-blow-effect");
var defaultRangeAreaFn = function () { return true; };
var spellEffectsMap = {
    'simpleAttack': simple_attack_effect_1.simpleAttackEffect,
    'move': move_effect_1.moveEffect,
    'sword-sting': sword_sting_effect_1.swordStingEffect,
    'side-attack': side_attack_effect_1.sideAttackEffect,
    'blood-sharing': blood_sharing_effect_1.bloodSharingEffect,
    'switch': switch_effect_1.switchEffect,
    'treacherous-blow': treacherous_blow_effect_1.treacherousBlowEffect,
    'attraction': attraction_effect_1.attractionEffect,
    'distraction': distraction_effect_1.distractionEffect,
    'slump': slump_effect_1.slumpEffect,
    'last-resort': last_resort_effect_1.lastResortEffect,
    'motivation': motivation_effect_1.motivationEffect
};
var getSpellEffectFn = function (spellRole) { return spellEffectsMap[spellRole].effect; };
exports.getSpellEffectFn = getSpellEffectFn;
var getSpellRangeAreaFn = function (spellRole) { var _a; return (_a = spellEffectsMap[spellRole].rangeArea) !== null && _a !== void 0 ? _a : defaultRangeAreaFn; };
exports.getSpellRangeAreaFn = getSpellRangeAreaFn;
